// extracted by mini-css-extract-plugin
export default {"navbar":"NavbarSupplier_navbar__Mh6Uf","logo":"NavbarSupplier_logo__DIWh9","navLinks":"NavbarSupplier_navLinks__YNrod","navItem":"NavbarSupplier_navItem__h56ji"};